import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class BlockLargeText {
    private block: HTMLElement;
    private svgs: SVGElement[] = [];
    private largeTextLeft: NodeListOf<HTMLElement>;
    private largeTextRight: NodeListOf<HTMLElement>;
    private largeTextCenter: NodeListOf<HTMLElement>;

    constructor(blockEl: HTMLElement) {
        this.block = blockEl;
        const bgContainer = this.block.querySelector<HTMLElement>(".largetext-bg");
        if (bgContainer) {
            this.svgs = Array.from(bgContainer.querySelectorAll<SVGElement>("svg"));
        }
        this.largeTextLeft = document.querySelectorAll(".largetext-left");
        this.largeTextRight = document.querySelectorAll(".largetext-right");
        this.largeTextCenter = document.querySelectorAll(".largetext-center");
    }

    public init() {
        if (!this.block || this.svgs.length === 0) return;

        const isLargeScreen = window.innerWidth >= 800; // 50rem = 800px

        let rotationSpeed = 30;
        let horizontalSpeed = 20;
        let verticalSpeedUp = "25%";
        let verticalSpeedDown = "-25%";

        if (!isLargeScreen) {
            rotationSpeed = 20;
            horizontalSpeed = 10;
            verticalSpeedUp = "15%";
            verticalSpeedDown = "-15%";
        }


        this.largeTextLeft.forEach((item, index) => {
            gsap.fromTo(
                item,
                {
                    opacity: 0,
                    x: -100,
                },
                {
                    opacity: 1,
                    x: 0,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 80%",
                        toggleActions: "play none none reverse",
                    },
                }
            );
        });

        this.largeTextRight.forEach((item, index) => {
            gsap.fromTo(
                item,
                {
                    opacity: 0,
                    x: 100,
                },
                {
                    opacity: 1,
                    x: 0,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 80%",
                        toggleActions: "play none none reverse",
                    },
                }
            );
        });

        this.largeTextCenter.forEach((item, index) => {
            gsap.fromTo(
                item,
                {
                    opacity: 0,
                    y: 100,
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 80%",
                        toggleActions: "play none none reverse",
                    },
                }
            );
        });


        // Animate each SVG with slight parallax and rotation
        this.svgs.forEach((svg, index) => {
            // Alternate direction based on index
            //const direction = index % 2 === 0 ? 1 : -1;

            let direction = 1;
            if (svg.classList.contains("svg-counterclockwise")) {
                direction = -1;
            }

            // Rotation
            gsap.to(svg, {
                rotation: direction * rotationSpeed, // rotate clockwise or counter-clockwise
                ease: "none",
                scrollTrigger: {
                    trigger: this.block,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 2, // slower rotation
                },
            });

            // Slight horizontal movement for depth
            gsap.to(svg, {
                x: direction * horizontalSpeed,
                ease: "none",
                scrollTrigger: {
                    trigger: this.block,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1.5,
                },
            });

            gsap.fromTo(
                svg,
                {
                    y: verticalSpeedDown, // start slightly above
                },
                {
                    y: verticalSpeedUp, // move slightly downward as you scroll
                    ease: "none",
                    scrollTrigger: {
                        trigger: this.block,
                        start: "top bottom", // when container enters viewport
                        end: "bottom top", // when it leaves
                        scrub: true, // makes it linked to scroll position
                    },
                }
            );
        });
    }

    public destroy() {
        ScrollTrigger.getAll().forEach((st) => {
            if (st.trigger === this.block) st.kill();
        });
    }
}

// Initialize multiple instances
function initBlockLargeText() {
    const blocks = Array.from(
        document.querySelectorAll<HTMLElement>(".blockLargeText")
    );
    if (blocks.length === 0) return;

    const instances: BlockLargeText[] = [];
    for (const el of blocks) {
        const instance = new BlockLargeText(el);
        instance.init();
        instances.push(instance);
    }
    (window as any)._blockLargeTextInstances = instances;
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBlockLargeText);
} else {
    initBlockLargeText();
}
